<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="15">
					<multi-select-combo
						:label="`${getMessage_('QWCC001137')} (${getMessage_('QWCC002020')})`"
						paramKey="powLnCd"
						:options="occuPlCdList"
						:propData="searchParams.powLnCd"
						@multiCommChange="setSearchParam"
					></multi-select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourPrvsMng/store/helpers';
import MultiSelectCombo from '@qms/Components/MultiSelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {
			searchDate: ''
		};
	},
	components: { MultiSelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				await this.getPowTourPrvsMngManagements_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error.message || error });
		}
	}
};
</script>

<style></style>
